import Backdraft from "backdraft-app/src/backdraft";

import template from "../templates/file_upload_dropzone_panel.jst";

import TimeZoneSelect from "shared/components/time_zone_select";
import Loading from "shared/loading";
import Toast from "shared/toast";

Backdraft.app("Shared/FileUpload", function(app) {
  app.view.panel("FileUploadDropzone", {

    title: "Upload New File",
    body: '<div data-mount="file-upload-dropzone-panel"></div>',

    events: {
      "click [data-action='download-template']": "_onDownloadTemplate"
    },

    buttons: function() {
      var self = this;
      return [
        {
          text: "Upload",
          className: "btn-primary",
          click: self._onUploadSubmit.bind(self)
        },
        {
          text: "Cancel",
          className: "btn-default margin-left-default",
          click: self._onUploadCancel.bind(self)
        }
      ];
    },

    initialize: function(options) {
      app.Views.FileUploadDropzone.__super__.initialize.apply(this, arguments);

      if (!options.dropzoneView) { throw new Error("dropzoneView is required"); }
      this.dropzoneView = options.dropzoneView;

      // Optional
      this.downloadTemplateUrl = options.downloadTemplateUrl;
      this.openDownloadTemplate = options.openDownloadTemplate;
      this.uploadButtonText = options.uploadButtonText || "Upload";
      this.timeZoneConfig = options.timeZoneConfig;
    },

    render: function() {
      app.Views.FileUploadDropzone.__super__.render.apply(this, arguments);

      this.$('[data-mount="file-upload-dropzone-panel"]').html(template({
        timeZoneConfig:      this.timeZoneConfig,
        downloadTemplateUrl: this.downloadTemplateUrl,
        uploadButtonText:    this.uploadButtonText
      }));
      this.$('[data-mount="file-upload-dropzone"]').html(this.dropzoneView.render().$el);

      this._initSetup();

      this.dropzoneView.on("removed_file", function() {
        this._toggleUploadButton();
      }.bind(this));

      this.dropzoneView.on("added_file", function() {
        this._toggleUploadButton();
      }.bind(this));

      this.dropzoneView.on("sending_file", function(file, xhr, formData) {
        if (this.timeZoneConfig) {
          var timeZone = this.child('timezonePicker').getSelectedTimeZone();
          formData.append("timezone", timeZone);
        }
      }.bind(this));

      this.dropzoneView.on("complete", function() {
        Loading.hide();
      });

      this.dropzoneView.on("error", function() {
        this._disableUploadButton();
      }.bind(this));

      return this;
    },

    _initSetup: function() {
      this._setupTimezonePicker();
      this._setUploadButtonText();
      this._toggleUploadButton();
      this._setupHelpTextPopovers();
    },

    _onUploadSubmit: function() {
      Toast.clear();
      if (!this.$("[data-action='upload-submit']").hasClass("disabled")) {
        if (this.dropzoneView.fileAdded()) {
          Loading.show(".panel", "Uploading File...");
          this.dropzoneView.submitFile();
        } else {
          Toast.error({ title: "No File Uploaded", message: "You must provide a file to upload.", sticky: true });
        }
      }
    },

    _onUploadCancel: function() {
      this.trigger("cancel_clicked");
    },

    _onDownloadTemplate: function() {
      this.openDownloadTemplate();
    },

    _setupHelpTextPopovers: function() {
      this.$('[data-help-popover="timezone-help-text-popover"]').helpPopover({
        content: "If your file doesn't contain the call's unique transaction ID or call record ID, the call start time is used to identify calls. This is the timezone of the call start time."
      });
    },

    _setUploadButtonText: function() {
      if (this.uploadButtonText) {
        this.$(".panel-footer .btn-primary").text(this.uploadButtonText);
      }
    },

    _toggleUploadButton: function() {
      if (this.dropzoneView.fileAdded()) {
        this._enableUploadButton();
      } else {
        this._disableUploadButton();
      }
    },

    _enableUploadButton: function() {
      const button = this.$(".panel-footer .btn-primary");
      button.removeClass("disabled").prop("disabled", false).popover("disable");
    },

    _disableUploadButton: function() {
      const button = this.$(".panel-footer .btn-primary");
      button.addClass("disabled").prop("disabled", true).popover({
        trigger: "hover",
        placement: "top",
        content: "Choose a file to upload."
      });
      this.$(".panel-footer .btn-primary").popover("enable");
    },

    _setupTimezonePicker: function() {
      if (this.timeZoneConfig) {
        this.child("timezonePicker", new TimeZoneSelect(
          this.timeZoneConfig.priorityTimeZones,
          this.timeZoneConfig.otherTimeZones,
          this.timeZoneConfig.currentUserTimeZone
        ));
        this.$("[data-mount='timezone-picker']").html(this.child("timezonePicker").render().$el);
      }
    }
  });
});
